export const opsgenieScheduleFeatureStates = {
	LOADING: 'LOADING',
	DISABLED: 'DISABLED',
	ENABLED: 'ENABLED',
} as const;

export type FeatureState = keyof typeof opsgenieScheduleFeatureStates;

export type State = {
	state: FeatureState;
};
